module.exports = __webpack_public_path__ + "img/main2.b203e9b7.jpg";